import { Injectable } from '@angular/core'
import { NbToastrService } from '@nebular/theme'
import { FFService } from '../../ff.service'

@Injectable( {
  providedIn: 'root',
} )
export class NotificationService {
  menu
  ff
  toastr
  notifications_dataset

  constructor(
    private ff_service: FFService,
    private toastrService: NbToastrService,
  ) {
    this.toastr = this.toastrService
    this.ff = this.ff_service.ff
    this.notifications_dataset = this.ff.dataset( {
      uri: 'placeholder',
      title: 'END OF NOTIFICATIONS',
      timestamp_epoch_ms: Date.now(),
    } )

    const data = [{
      mime_type: 'descriptive/definition',
      name: 'Notification Service',
      title: 'Portal Notification Service',
      subtitle: 'A Fancy Framework Notification Service',
      headline: 'A Fancy Framework Notification Service',
      description: 'The FF Notification Service creates toasts for ' +
        'the end user when it is told to do so through delivery.',
      short_description: 'This service creates growl messages for the end user.',
      description_list: ['Create growl messages', 'Improve user experience'],
      keywords: ['UX', 'UI', 'growl'],
      icon: 'fal fa-comment-alt-times',
      category: 'fancy_framework',
      subcategory: 'service',
    }, {
      mime_type: 'subsystem/definition',
      subsystem: 'notification',
    }, {
      mime_type: 'system/definition',
      system: 'ff',
    }, {
      mime_type: 'service/definition',
      service: 'notification',
    }]

    const options = [{
      mime_type: 'action_function/definition',
      action_function: this.handle_notifications.bind( this ),
    }, {
      mime_type: 'subscription_function/definition',
      subscription_function: () => true,
    }]

    const scope = []

    this.ff.service( data, options, scope )
  }

  handle_notifications ( message ) {
    message.payload.filter( ( item ) => {
      const is_notification = item.mime_type === 'notification/message'
      const is_error = item.has_error
      return is_notification || is_error
    } ).forEach( ( item ) => {
      console.log( 'Notification payload:', item )

      // 'catastrophic' | 'serious' | 'moderate' | 'minor' | 'negligible'
      switch ( item.severity ) {
        case 'minor':
          this.toastr.warning( item.description, item.title )
          break
        case 'catastrophic':
          this.toastr.danger( item.description, item.title )
          break
        case 'serious':
          this.toastr.danger( item.description, item.title )
          break
        case 'moderate':
          this.toastr.danger( item.description, item.title )
          break
        case 'negligible':
          this.toastr.info( item.description, item.title )
          break
        default:
          this.toastr.default( item.description, item.title )
          break
      }
      this.notifications_dataset.add( { ...item, ...{ icon: 'alert-circle-outline', timestamp_epoch_ms: Date.now() } } )
    } )

    message.payload.filter( ( item ) => {
      const is_event = item.is_error
      return is_event
    } ).forEach( ( item ) => {
      this.toastr.default( item.description, item.title )
      this.notifications_dataset.add( { ...item, ...{ icon: 'info-outline', timestamp_epoch_ms: Date.now() } } )
    } )
    /*
      if ( !environment.production ) {
        message.payload.filter( ( item ) => {
          const action = item.hasOwnProperty( 'action' )
          return action
        } ).forEach( ( action ) => {
          this.toastr.default( action.description, action.action )
          this.notifications_dataset.add( {
            ...action, ...{
              icon: 'settings-outline',
              timestamp_epoch_ms: Date.now(),
              title: action.action,
            }
          } )
        } )
      }
    */
    const sorted = this.notifications_dataset.sort( ['timestamp_epoch_ms'], ['desc'] )
    this.notifications_dataset.destroy()
    sorted.forEach( ( datum ) => this.notifications_dataset.add( datum ) )
  }
}

